///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { MentionsInput, Mention } from "react-mentions";

import messages from "../../../helpers/messages";

const defaultStyle = {
  control: {
    backgroundColor: "#eff2fa",
    fontSize: 12,
    fontWeight: "normal"
  },
  "&multiLine": {
    control: {
      fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
      minHeight: 16
    },
    highlighter: {
      padding: 0,
      border: "none",
      boxSizing: "border-box",
      minHeight: 14
    },
    input: {
      padding: 0,
      border: "none",
      boxShadow: "none",
      minHeight: 14
    }
  },
  suggestions: {
    list: {
      backgroundColor: "white",
      fontSize: 14,
      borderRadius: 4,
      boxShadow:
        "0 1px 3px 0 rgba(0,0,0,0.2), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 1px 0 rgba(0,0,0,0.14)"
    },
    item: {
      padding: "7px 14px",
      fontSize: 12,
      "&focused": {
        backgroundColor: "#F5F5F6"
      }
    }
  }
};

const MessageInput = ({
  value,
  onChange,
  maxLength,
  fetchUsers,
  container
}) => {
  const handleChange = (event, newValue) =>
    newValue.length <= maxLength && onChange(newValue);

  return (
    <div className="message-input-container">
      <MentionsInput
        className="message-input resize-none scroll"
        value={value}
        onChange={handleChange}
        style={defaultStyle}
        placeholder={messages.typeSomething.defaultMessage}
        maxLength={maxLength}
        suggestionsPortalHost={container}
      >
        <Mention
          displayTransform={(id, display) => `@${display}`}
          trigger="@"
          data={fetchUsers}
        />
      </MentionsInput>
    </div>
  );
};

export default MessageInput;
